<mat-drawer-container>
  <mat-drawer #drawer mode="side" opened disableClose autosize>
    <div class="flex-column">
      <header> State Report Builder</header>
      <mat-form-field appearance="outline" floatLabel="always">
        <mat-label> State</mat-label>
        <mat-select [value]="selectedAbbreviation()" (selectionChange)="navigate({stateAbbr: $event.value})">
          @for (state of stateOptions(); track state.geoid) {
            <mat-option [value]="state.abbreviation"> {{ state.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" floatLabel="always">
        <mat-label> Year</mat-label>
        <mat-select [value]="selectedYear()" (selectionChange)="navigate({year: $event.value})">
          @for (year of yearOptions(); track year) {
            <mat-option [value]="year"> {{ year }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <header> Table of Contents</header>
      <nav>
        @for (link of pageRoutes(); track link.route) {
          <a [routerLink]="link.route" [class.active]="link.active">
            {{ link.display }} </a>
        }
      </nav>
    </div>
  </mat-drawer>
  @if (locationService.loadingCounties()) {
    <tgrid-loading-mask message="Loading Counties"/>
  } @else {
    <div class="content-area">
      <div class="flex-column">
        @switch (selectedPage()) {
          @case ('appendix') {
            <tgrid-appendix-page/>
          }
          @case ('cost-outage') {
            <tgrid-cost-outage-page></tgrid-cost-outage-page>
          }
          @case ('outage-data') {
            <tgrid-outage-data-page></tgrid-outage-data-page>
          }
          @case ('restoration') {
            <tgrid-restoration-metric-page/>
          }
          @case ('reliability') {
            <tgrid-statewide-reliability-page/>
          }
          @case ('resilience') {
            <tgrid-system-resilience-page/>
          }
        }
      </div>
    </div>
  }
</mat-drawer-container>
